const rollDie = (min, max) => {
  return min - 1 + Math.ceil(Math.random() * (max - min + 1));
};

const oracleRoll = (max) => {
  if (!max) {
    max = 100;
  }
  const result = rollDie(1, max)
  return result;
};

const challengeRoll = bonus => {
  let result = {
    actionDie: null,
    challenge1: null,
    challenge2: null,
  };

  result.actionDie = rollDie(1, 6);
  result.challenge1 = rollDie(1, 10);
  result.challenge2 = rollDie(1, 10);

  const resultTotal = result.actionDie + bonus;

  var resultScore = 0;
  if (resultTotal > result.challenge1) {
    resultScore += 1;
  }
  if (resultTotal > result.challenge2) {
    resultScore += 1;
  }

  switch (resultScore) {
    case 0:
      result.type = 'm';
      result.text = 'Miss';
      break;
    case 1:
      result.type = 'wh';
      result.text = 'Weak Hit';
      break;
    case 2:
      result.type = 'sh';
      result.text = 'Strong Hit';
      break;
  }

  result.match = result.challenge1 === result.challenge2 ? true : false;

  return result;
};

export default {rollDie, challengeRoll, oracleRoll};
